module.exports = __webpack_public_path__ + "95860428dc092dacf61150187d2df301.svg";